import React, { useEffect, useMemo, useState } from 'react'
import LocationIcon from '../icons/LocationIcon'
import { Address, Coordinates } from '../../types/address';
import { storeAddress } from '../../services/api/address';
import { toast } from 'react-toastify';
import { getErrorMessage } from '../../utils/helpers';

interface CompleteAddressProps {
    coords: Coordinates,
    onCancel: () => void,
    afterSubmit: (uuid: string) => void,
    decodedAddress: Address
}



const CompleteAddress: React.FC<CompleteAddressProps> = ({ onCancel, afterSubmit, decodedAddress }) => {

    const [loading, setLoading] = useState(false);

    const [address, setAddress] = useState<Address>({
        ...decodedAddress,
        name: 'Home',
    })

    useEffect(() => {
        if (decodedAddress) {
            setAddress((prev) => {
                return {
                    ...decodedAddress,
                    name: prev.name || 'Home',
                }
            })
        }
    }, [decodedAddress])

    const handleChange = (key: keyof Address, value: string) => {
        setAddress({ ...address, [key]: value })
    }

    const isAddressName = (name: string) => {
        if (name === 'Other' && !['Home', 'Work'].includes(address.name)) return true;
        if (address.name === name) return true;
    }

    const addAddress = async () => {
        if (!isValid()) return false;
        try {
            setLoading(true)
            const {uuid} =await storeAddress(address);

            afterSubmit(uuid);
        } catch (error: any) {
            toast.error(getErrorMessage(error));
            console.log(error)
        } finally {
            setLoading(false);
        }
    }

    const isValid = () => {
        if (!address.premise || !address.sublocality || !address.pincode) return false;
        return true;
    }

    return (
        <div className="located-address mt-3">
            <div className="located-address-content pt-0">
                <div className="located-address-content-secondary d-flex justify-content-between align-items-center gap-2">
                    {
                        <span>{decodedAddress?.formatted}</span>
                    }
                    <button onClick={onCancel} className="change-location-btn">Change</button>
                </div>
                <div className="located-address-form pt-3">
                    <div className='address-form-group'>
                        <label className='address-1'>House / Flat / Floor no. <span className="text-danger">*</span></label>
                        <input type='text' value={address.premise} onChange={(e) => handleChange('premise', e.target.value)} className='form-control' />
                    </div>
                    <div className='address-form-group'>
                        <label className='address-2'>Apartment / Road/ Area <span className="text-danger">*</span></label>
                        <input type='text' value={address.sublocality} onChange={(e) => handleChange('sublocality', e.target.value)} className='form-control' />
                    </div>
                    <div className='address-form-group'>
                        <label className='address-2'>Pincode <span className="text-danger">*</span></label>
                        <input type='text' value={address.pincode} onChange={(e) => handleChange('pincode', e.target.value)} className='form-control' />
                    </div>
                    <div className='address-form-group'>
                        <label className='address-2'>Save As</label>
                        <div className="d-flex gap-2">
                            <div className={`address-type ${isAddressName('Home') ? 'selected' : ''}`} onClick={() => handleChange('name', 'Home')}>
                                Home
                            </div>
                            <div className={`address-type ${isAddressName('Work') ? 'selected' : ''}`} onClick={() => handleChange('name', 'Work')}>
                                Work
                            </div>
                            <div className={`address-type ${isAddressName('Other') ? 'selected' : ''}`} onClick={() => handleChange('name', '')}>
                                Other
                            </div>
                        </div>
                        {
                            isAddressName('Other') &&
                            <input type='text' placeholder="e.g. Friend's Home, New Office" value={address.name} onChange={(e) => handleChange('name', e.target.value)} className='form-control' />
                        }
                    </div>
                    <button onClick={addAddress} disabled={!isValid() || loading} className='btn-primary btn'>Save Address</button>
                </div>
            </div>
        </div>
    )
}

export default CompleteAddress  